import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'
import { IPortalUnitSearchParamsModel } from '@apps-common/types/management/unit'

export const QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT = (params?: IPortalUnitSearchParamsModel) =>
  [
    'searchPortalUnitsCount',
    params?.status,
    params?.mCentreId,
    params?.bureauId,
    params?.techCompanyId,
    params?.networkType,
    params?.site,
    params?.accountNo,
    params?.mobileNo,
    params?.imei,
    params?.isActivated,
    params?.pinnedUnits,
    params?.orderBy,
    params?.skip,
    params?.take,
    params?.hasNoActivation
  ].filter(Boolean)

export const searchPortalUnitsCount = async (params: IPortalUnitSearchParamsModel): Promise<ISearchCountModel> =>
  axios.post(`/Unit/SearchUnitsCount`, params).then((res) => res.data?.data)

type QueryFnType = typeof searchPortalUnitsCount

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IPortalUnitSearchParamsModel
}

export const usePortalSearchUnitsCount = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT(model),
    queryFn: () => searchPortalUnitsCount(model)
  })
